// extracted by mini-css-extract-plugin
module.exports = {"mocktale":"CRa5u"};